// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ShipWheel,
    Shirt,
    ShoppingBag,
    ShoppingBasket,
    ShoppingCart,
    ShoppingCartMinus,
    ShoppingCartPlus,
    Shovel,
    ShowerHead,
    Shredder,
    Shrimp,
    ShrimpOff,
    Shrink,
    Shrub,
    Shuffle,
    Sigma,
    Signal,
    SignalHigh,
    SignalLow,
    SignalMedium,
    SignalZero,
    Signature,
    Signpost,
    SignpostBig,
    Siren,
    SkipBack,
    SkipForward,
    Skull,
    Slash,
    Slice,
    SlidersHorizontal,
    SlidersVertical,
    Smartphone,
    SmartphoneCharging,
    SmartphoneNfc,
    Snail,
    Snowflake,
    SoapDispenserDroplet,
    Sofa,
    SolarPanel,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "ship-wheel" through "solar-panel", inclusive. */
const shard: Record<string, LucideIcon> = {
    "ship-wheel": ShipWheel,
    shirt: Shirt,
    "shopping-bag": ShoppingBag,
    "shopping-basket": ShoppingBasket,
    "shopping-cart": ShoppingCart,
    "shopping-cart-minus": ShoppingCartMinus,
    "shopping-cart-plus": ShoppingCartPlus,
    shovel: Shovel,
    "shower-head": ShowerHead,
    shredder: Shredder,
    shrimp: Shrimp,
    "shrimp-off": ShrimpOff,
    shrink: Shrink,
    shrub: Shrub,
    shuffle: Shuffle,
    sigma: Sigma,
    signal: Signal,
    "signal-high": SignalHigh,
    "signal-low": SignalLow,
    "signal-medium": SignalMedium,
    "signal-zero": SignalZero,
    signature: Signature,
    signpost: Signpost,
    "signpost-big": SignpostBig,
    siren: Siren,
    "skip-back": SkipBack,
    "skip-forward": SkipForward,
    skull: Skull,
    slash: Slash,
    slice: Slice,
    "sliders-horizontal": SlidersHorizontal,
    "sliders-vertical": SlidersVertical,
    smartphone: Smartphone,
    "smartphone-charging": SmartphoneCharging,
    "smartphone-nfc": SmartphoneNfc,
    snail: Snail,
    snowflake: Snowflake,
    "soap-dispenser-droplet": SoapDispenserDroplet,
    sofa: Sofa,
    "solar-panel": SolarPanel,
};

export default shard;
